export default __webpack_public_path__ + "static/media/indonesia2018B.329d987a.jpg";